import styled from 'styled-components';

export const ProductsContainer = styled.div`
  background-color: rgb(251, 251, 251);
`;
